// window.LUM — Lumberjack tool map. 18 positions, all on face A (every feature is a through-cut or an edge).
// mx/my = millimetres on face A (mx from its left edge, my from its top), measured off https://mrf.tools/cdn/shop/files/mrf26-lum.stl?v=b3:
// hex sizes are across-flats from the mesh walls, so each opening carries +0.05…0.11 mm of wrench clearance.
window.LUM = {
  blocks: [
    { label: 'EDGE & ENDS', tools: [
      { n: 1, side: 'A', mx: 9.9, my: 41, est: false, name: 'Saw comb', cat: 'GROOMING',
        desc: '20 machined teeth along the whole long edge — cut, not moulded, so they hold a beard or a moustache in line without flexing.',
        sc: 'The comb is the reason the card exists: it is the only grooming tool that survives airport security.' },
      { n: 2, side: 'A', mx: 55, my: 39.9, est: false, name: 'Bottle opener', cat: 'EVERYDAY',
        desc: 'A hook cut 20 mm into the opposite long edge: the lip catches the crown, the plate takes the leverage.',
        sc: 'Hook the cap, press once with a finger — the geometry does the work, not your wrist.' },
      { n: 3, side: 'A', mx: 55, my: 79.3, est: false, name: 'Flat screwdriver', cat: 'DRIVE',
        desc: 'The bevelled tip at the bottom corner, backed by the full 2 mm of the plate.',
        sc: 'Battery covers, switch plates, hose clamps — the jobs that never happen near a toolbox.' },
      { n: 4, side: 'A', mx: 55, my: 4.8, est: false, name: 'Box opener', cat: 'EVERYDAY',
        desc: 'A beak with a guard behind it at the top corner: it parts tape and cardboard without a live blade.',
        sc: 'Drag the beak along the seam — the guard stops it before it reaches what is inside the box.' }
    ] },
    { label: 'HEX · METRIC', tools: [
      { n: 5, side: 'A', mx: 32.0, my: 9.5, est: false, name: '13 mm hex', cat: 'WRENCH',
        desc: 'Largest metric opening on the card, top row.', sc: 'M8 hardware, seat posts, trailer bolts.' },
      { n: 6, side: 'A', mx: 45.5, my: 10.8, est: false, name: '12 mm hex', cat: 'WRENCH',
        desc: 'Top row, next to the 13.', sc: 'M8 nuts on the metric side of the shed.' },
      { n: 7, side: 'A', mx: 36.8, my: 21.6, est: false, name: '10 mm hex', cat: 'WRENCH',
        desc: 'Second row.', sc: 'The size that fits most of a bicycle.' },
      { n: 8, side: 'A', mx: 48.4, my: 23.2, est: false, name: '9 mm hex', cat: 'WRENCH',
        desc: 'Second row, edge side.', sc: 'Small brackets and clamp bolts.' },
      { n: 9, side: 'A', mx: 40.0, my: 51.3, est: false, name: '8 mm hex', cat: 'WRENCH',
        desc: 'Middle of the field, under the logo cut.', sc: 'M5 hardware — furniture, luggage racks.' },
      { n: 10, side: 'A', mx: 32.4, my: 29.9, est: false, name: '6 mm hex', cat: 'WRENCH',
        desc: 'Small opening, third row.', sc: 'M4 nuts and grub screws.' },
      { n: 11, side: 'A', mx: 50.2, my: 31.0, est: false, name: '5.5 mm hex', cat: 'WRENCH',
        desc: 'Edge-side opening, third row.', sc: 'The classic RC and hobby size.' },
      { n: 12, side: 'A', mx: 42.0, my: 30.3, est: false, name: '5 mm hex', cat: 'WRENCH',
        desc: 'Third row, middle.', sc: 'M3 nuts, terminal blocks.' },
      { n: 13, side: 'A', mx: 28.1, my: 21.4, est: false, name: '4.5 mm hex', cat: 'WRENCH',
        desc: 'Smallest opening on the card.', sc: 'Spectacle hinges and electronics hardware.' }
    ] },
    { label: 'HEX · IMPERIAL', tools: [
      { n: 14, side: 'A', mx: 29.4, my: 75.5, est: false, name: '9/16 in hex', cat: 'WRENCH',
        desc: 'Largest imperial opening — 14.29 mm across flats.', sc: 'US plumbing and trailer hardware.' },
      { n: 15, side: 'A', mx: 45.3, my: 71.6, est: false, name: '1/2 in hex', cat: 'WRENCH',
        desc: '12.70 mm across flats.', sc: 'The most common SAE bolt head in a garage.' },
      { n: 16, side: 'A', mx: 35.7, my: 61.5, est: false, name: '7/16 in hex', cat: 'WRENCH',
        desc: '11.11 mm across flats.', sc: 'Small engine and mower hardware.' },
      { n: 17, side: 'A', mx: 48.5, my: 58.3, est: false, name: '3/8 in hex', cat: 'WRENCH',
        desc: '9.53 mm across flats.', sc: 'Appliance and HVAC service nuts.' },
      { n: 18, side: 'A', mx: 31.3, my: 52.3, est: false, name: '1/4 in hex', cat: 'WRENCH',
        desc: '6.35 mm across flats — smallest imperial opening.', sc: 'Sheet-metal screws and hose clamps.' }
    ] }
  ]
};
